import React from "react";
import classNames from "classnames";

import BaseReportTable from "./BaseReportTable";

import "components/reportTable/reportTable.scss";

interface IProps {
    data: Array<Record<string, any>>;
    columns: Array<Record<string, any>>;
    description: string;
    compileDate: string;
}

export default function LoyaltyProgramPointsBalanceTable(props: IProps) {
    function formatDisplay(type: string, value: string) {
        const newValue = value !== null && value !== undefined ? value : "";

        if (newValue !== "") {
            switch (type) {
                default:
                    break;
            }
        }

        return newValue;
    }

    function cellData(columnId: string, cellValue: string, displayType: string) {
        switch (columnId) {
            default:
                return formatDisplay(displayType, cellValue);
        }
    }

    function rowClassNames(row: any) {
        return classNames({
            "report-table-row": !row.original?.subRows,
            "report-table-row-total": !!row.original?.subRows,
        });
    }

    function cellClassNames(cell: any, isRowLocked: boolean) {
        const original = cell.row?.original;
        const isClickableRow = !cell.isGrouped && !cell.isAggregated;

        return classNames({
            "report-table-row-locked": isRowLocked,
            "report-table-cell-clickable":
                isClickableRow &&
                ((cell.column.id === "customer" && original?.customer_id)),
        });
    }

    function cellOnClick(cell: any) {
        if (!cell || cell.isGrouped || cell.isAggregated) {
            return null;
        }

        const original = cell.row?.original;

        if (cell.column.id === "customer" && original?.customer) {
            return window.open(`/admin/customers/${original?.customer_id}/profile`);
        }

        return null;
    }

    function footerData(columnId: string, footerRow?: Record<string, any>) {
        if (!footerRow) {
            return null;
        }

        switch (columnId) {
            case "cost":
                return formatDisplay("currency", String(footerRow[columnId] ?? 0));
            default:
                return (footerRow[columnId] as string) ?? null;
        }
    }

    return (
        <BaseReportTable
            data={props.data}
            columns={props.columns}
            description={props.description}
            compileDate={props.compileDate}
            cellOnClick={cellOnClick}
            cellData={cellData}
            rowClassNames={rowClassNames}
            cellClassNames={cellClassNames}
            footerData={footerData}
            expanding={true}
            expandingColumn="type"
        />
    );
}
